export const DEFAULT_PAGE_SETTINGS = {
    meta_description: '',
    primary_color: '#10b981',
    font_family: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
}

export const SECTION_TYPES = [
    { type: 'hero', name: 'Hero', description: 'Headline, subtext, and CTA buttons', icon: 'page' },
    { type: 'features', name: 'Features', description: 'Highlight product benefits with icons', icon: 'tick' },
    { type: 'cta', name: 'Call to Action', description: 'Conversion-focused banner section', icon: 'arrow-right' },
    { type: 'faq', name: 'FAQ', description: 'Accordion-style questions and answers', icon: 'faq' },
    { type: 'testimonials', name: 'Testimonials', description: 'Customer quotes and social proof', icon: 'user' },
]

export function defaultSectionStyles() {
    return {
        backgroundColor: '#ffffff',
        padding: '60px 20px',
        textAlign: 'center',
    }
}

export function createSectionId() {
    return `section_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`
}

export function createSection(type) {
    const baseSection = {
        id: createSectionId(),
        type,
        content: {},
        styles: defaultSectionStyles(),
    }

    switch (type) {
        case 'hero':
            baseSection.content = {
                headline: 'Welcome to Our Platform',
                subheadline: 'Build amazing landing pages in minutes',
                ctaText: 'Get Started',
                ctaLink: '#',
                ctaStyle: 'primary',
                secondaryCtaText: '',
                secondaryCtaLink: '',
                backgroundImage: '',
            }
            baseSection.styles = {
                ...defaultSectionStyles(),
                backgroundColor: '#0f172a',
                headlineColor: '#ffffff',
                subheadlineColor: '#cbd5e1',
            }
            break
        case 'features':
            baseSection.content = {
                title: 'Why Choose Us',
                subtitle: 'Everything you need to launch faster',
                items: [
                    { title: 'Fast Setup', description: 'Go live in minutes with drag-and-drop sections.', icon: 'tick' },
                    { title: 'Mobile Ready', description: 'Every page looks great on phones and tablets.', icon: 'phone' },
                    { title: 'Easy Sharing', description: 'Publish and share a unique link instantly.', icon: 'page' },
                ],
            }
            break
        case 'cta':
            baseSection.content = {
                title: 'Ready to get started?',
                subtitle: 'Join thousands of users building with ProfileSuite.',
                ctaText: 'Start Free',
                ctaLink: '#',
            }
            baseSection.styles = {
                ...defaultSectionStyles(),
                backgroundColor: '#10b981',
                textColor: '#ffffff',
            }
            break
        case 'faq':
            baseSection.content = {
                title: 'Frequently Asked Questions',
                items: [
                    { question: 'How do I publish my page?', answer: 'Click Publish in the editor, then share your public link.' },
                    { question: 'Can I edit sections later?', answer: 'Yes. Open the page anytime and update your content.' },
                    { question: 'Is it mobile friendly?', answer: 'All landing page sections are responsive by default.' },
                ],
            }
            baseSection.styles = {
                ...defaultSectionStyles(),
                textAlign: 'left',
            }
            break
        case 'testimonials':
            baseSection.content = {
                title: 'What Customers Say',
                items: [
                    { quote: 'This tool helped us launch our campaign in one afternoon.', author: 'Alex Morgan', role: 'Marketing Lead' },
                    { quote: 'Simple, clean, and effective for our product pages.', author: 'Jamie Lee', role: 'Founder' },
                ],
            }
            break
        default:
            break
    }

    return baseSection
}

export function getSectionComponentName(type) {
    const map = {
        hero: 'HeroSection',
        features: 'FeaturesSection',
        cta: 'CtaSection',
        faq: 'FaqSection',
        testimonials: 'TestimonialsSection',
    }
    return map[type] || 'div'
}

export function getSectionEditorName(type) {
    const map = {
        hero: 'HeroSectionEditor',
        features: 'FeaturesSectionEditor',
        cta: 'CtaSectionEditor',
        faq: 'FaqSectionEditor',
        testimonials: 'TestimonialsSectionEditor',
    }
    return map[type] || 'div'
}

export function getSectionLabel(type) {
    return SECTION_TYPES.find((item) => item.type === type)?.name || type
}
